"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    m: 660,
    l: 900,
    xl: 1280,
};
